import NoPage from "./NoPage";
export default NoPage;
